<template lang="pug">
  v-row
    v-col
      div(class="text-center")
        v-progress-circular(v-if="isLoading" size="70" color="primary" indeterminate)
        span(v-if="errors.emptyCode") Отсутствует код авторизации
        span(v-if="errors.wrongCode") Неверный код авторизации

</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'AuthorizeOutside',
  data: () => ({
    errors: {
      emptyCode: false,
      wrongCode: false,
    },
    isLoading: false,
  }),
  mounted() {
    const { code } = this.$route.query;
    if (!code) {
      this.errors.emptyCode = true;
      return;
    }
    this.loginByCode(code);
  },
  methods: {
    ...mapActions({ AUTHENTICATE_BY_CODE: 'auth/AUTHENTICATE_BY_CODE' }),
    loginByCode(key) {
      this.isLoading = true;
      this.AUTHENTICATE_BY_CODE({ key })
        .then(() => {
          const redirectUrl = this.$route.query.redirect_url;
          this.isLoading = false;
          if (redirectUrl) {
            this.$router.push({ path: redirectUrl });
          } else {
            this.$router.push({ name: 'CourseList' });
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.errors.wrongCode = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
